export const FundSelector = {
  state: (state) => state.ultrahigh.fund,
  loading: (state) => FundSelector.state(state).loading,
  fundList: (state) => FundSelector.state(state).fundList,
  
  total: (state) => FundSelector.state(state).total,
  paginable: (state) => FundSelector.state(state).paginable,
  endPaging: (state) => FundSelector.state(state).endPaging,

  fetchingFundDetail: state => FundSelector.state(state).fetchingFundDetail,
  fetchingNavDetailList: state => FundSelector.state(state).fetchingNavDetailList,
  fundDetail: state => FundSelector.state(state).fundDetail ?? {},
  navDetailList: state => FundSelector.state(state).navDetailList ?? [],
  condition: state => FundSelector.state(state).condition,

  factSheetFile: state => FundSelector.state(state).factSheetFile,
  urlFactsheet: state => FundSelector.state(state).urlFactsheet,
}